module.exports = __webpack_public_path__ + "assets/honeywellsanstt-book-19c6d2.ttf";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/Content/fonts/honeywellsanstt-book.ttf
 ** module id = 943
 ** module chunks = 2
 **/